import styled from 'styled-components';

import media from '../../../styles/media.style';
import { BG_GRAY, PAGE_WIDTH, WHITE, BLACK } from '../../../styles/variables.style';

const CELL_SIZE = PAGE_WIDTH / 4 + 5;
const MOBILE_CELL_SIZE = 250;

export const Wrapper = styled.section`
  overflow: hidden;
  padding: 20px 0;

  main div section + & {
    margin: 60px 0 0;
  }

  ${media.tabletL`
    padding: 60px 0 80px 0;
  `};
`;

export const GridWrapper = styled.div`
  display: none;
  margin: 0 auto;
  max-width: ${PAGE_WIDTH}px;
  width: 100%;

  ${media.tabletL`
    display: flex;
    flex-wrap: wrap;
    grid-template-columns: repeat(auto-fill, minmax(${CELL_SIZE}px, 1fr));
    /* justify-content: center; */
  `};
`;

export const SliderWrapper = styled.div`
  display: block;
  width: ${MOBILE_CELL_SIZE}px;

  & > div > div {
    width: ${MOBILE_CELL_SIZE}px;
    overflow: visible !important;
  }

  ${media.tabletL`
    display: none;
  `};
`;

export const TitleCell = styled.div`
  position: relative;

  ${media.tabletL`
    min-height: ${CELL_SIZE}px;
    width: calc(100% / 3);
  `};
`;

export const TitleCellFiller = styled.div`
  padding-bottom: 100%;
  width: 100%;
`;

export const TitleCellContent = styled.div`
  align-items: center;
  background-color: ${BLACK};
  color: ${WHITE};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;

  > h5 {
    color: inherit;
    font-size: 14px;
    text-transform: uppercase;
    max-width: 30%;
  }

  ${media.tabletL`
    > h5 {
      font-size: 18px;
    }
  `};
`;

export const StyleCell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: ${MOBILE_CELL_SIZE}px;
  overflow: hidden;

  ${media.tabletL`
    min-height: ${CELL_SIZE}px;
    width: calc(100% / 3);
  `};
`;

export const CellInner = styled.div`
  width: 100%;
`;

export const Title = styled.h5`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.9px;
  margin: 0 auto 50px;
  position: relative;
  text-align: center;

  ${media.tabletL`
    font-size: 18px;
    letter-spacing: 0.7px;
    margin: 0 auto 85px;
  `};

  &::after {
    content: '';
    position: absolute;
    bottom: -25px;
    left: calc(50% - 20px);
    width: 30px;
    height: 2px;
    background: ${BG_GRAY.COMMON_6};
  }
`;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/StylesGallery/StylesGallery.style.js